export var randomColor = function () { return "hsl(".concat(Math.floor(360 * Math.random()), ",70%,20%)"); };
//# sourceMappingURL=randomColor.js.map